import { link } from "fs";
import { routes } from "../../routers/routes";
import { MenuItem } from "../../types/Layout";

export const menuList: MenuItem[] | undefined = [
  
  {
    title : "MapView",
    Items:[
      {
        id : 1,
        title : "MapView",
        type:"link",
         icon: "icon-map",
         url: routes.MapView,
      },
     
    ]
  },
 
  
  
];
